
<template>
    <div>
        <div class="upgrade-form py-4 px-5">
            <h2 class="text-center mb-4">Select Plan</h2>
            <div class="plans">
                <b-row>
                    <b-col>
                        <b-card id="essential">
                            <div class="px-3">
                                <h3 class="card-title text-center mb-3">Essential</h3>
                                <h5 class="price text-center mb-4">2,499/month</h5>
                                <b-button block variant="primary" class="green-btn" to="/upgrade/step-2">Upgrade Now</b-button>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card id="professional">
                            <div class="px-3">
                                <h3 class="card-title text-center mb-3">Professional</h3>
                                <h5 class="price text-center mb-4">Php 14,999/month</h5>
                                <b-button block variant="primary" class="yellow-btn" to="/upgrade/step-2">Upgrade Now</b-button>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col>
                        <b-card id="enterprise">
                            <div class="px-3">
                                <h3 class="card-title text-center mb-3">Enterprise</h3>
                                <h5 class="price text-center mb-4">Php 49,999/month</h5>
                                <b-button block variant="primary" class="blue-btn" to="/upgrade/step-2">Upgrade Now</b-button>
                            </div>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="upgrade-form pb-2">
            <h4 id="features-heading" class="text-center" v-b-toggle.collapse-1>See Plans Features</h4>
            <b-collapse id="collapse-1" visible>
                <div id="features" class="pt-3 px-5">
                    <b-row>
                        <b-col>
                            <b-table :fields="fields" :items="items" borderless>
                                <template slot="essential" slot-scope="data">
                                    <template v-if="data.value == 1">
                                        <img src="@/assets/images/setup/table-check.svg" alt="Check">
                                    </template>
                                    <template v-else-if="data.value != 0">
                                        {{ data.value }}
                                    </template>
                                </template>
                                <template slot="professional" slot-scope="data">
                                    <template v-if="data.value == 1">
                                        <img src="@/assets/images/setup/table-check.svg" alt="Check">
                                    </template>
                                    <template v-else-if="data.value != 0">
                                        {{ data.value }}
                                    </template>
                                </template>
                                <template slot="enterprise" slot-scope="data">
                                    <template v-if="data.value == 1">
                                        <img src="@/assets/images/setup/table-check.svg" alt="Check">
                                    </template>
                                    <template v-else-if="data.value != 0">
                                        {{ data.value }}
                                    </template>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                </div>
            </b-collapse>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'start',
    data() {
        return {
            fields: [
                { key: "features", label: "Features" },
                { key: "essential", label: "Essential" },
                { key: "professional", label: "Professional" },
                { key: "enterprise", label: "Enterprise" }
            ],
            items: [
                { features: 'Channels', essential: '', professional: '', enterprise: '' }, // Heading
                { features: 'Merchant Web Portal', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Customer Web Portal', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Customer App - iOS and Android', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Merchant Androi App', essential: '0', professional: '1', enterprise: '1' },
                { features: 'API Access', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Mechanics', essential: '', professional: '', enterprise: '' }, // Heading
                { features: 'Points Conversion', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Expiry of Points', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Points Transfer', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Achievement Unlock', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Refer a Friend', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Rewards', essential: '', professional: '', enterprise: '' }, // Heading
                { features: 'Rewards Catalog', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Instant Gratification', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Voucher Management', essential: '0', professional: '0', enterprise: '1' },
                { features: 'Engagement', essential: '', professional: '', enterprise: '' }, // Heading
                { features: 'SMS', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Email', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Push Notification', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Report', essential: '', professional: '', enterprise: '' }, // Heading
                { features: 'Transaction History', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Analytics', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Customer Single - View', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Top-Ups (per month)', essential: '', professional: '', enterprise: '' }, // Heading
                { features: 'E-Store', essential: '', professional: 'Php 7,500', enterprise: 'Php 5,000' },
                { features: 'Class Booking', essential: '', professional: 'Php 5,000', enterprise: 'Php 3,000' },
                { features: 'Restaurant Reservation', essential: '', professional: 'Php 3,000', enterprise: 'Php 2,000' },
                { features: 'Whitelisting', essential: '', professional: 'Php 2,000', enterprise: 'FREE' },
                { features: 'Customer Single - View', essential: '', professional: '', enterprise: 'FREE' },
                { features: 'Support', essential: '', professional: '', enterprise: '' }, // Heading
                { features: 'Email', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Chat (via Viber)', essential: '0', professional: '0', enterprise: '1' },
                { features: 'Phone', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Consultation', essential: 'Bi-Annual', professional: 'Quarterly', enterprise: 'Monthly' }, // Heading
                { features: 'Live Webinar', essential: '1', professional: '1', enterprise: '1' },
                { features: 'Group On-Boarding', essential: '0', professional: '1', enterprise: '1' },
                { features: 'Private On-Boarding', essential: '0', professional: '0', enterprise: '1' },
            ]
        }
    },
    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        }
    }
};
</script>
<style lang="scss">
</style>